// extracted by mini-css-extract-plugin
module.exports = {"container":"Canvas_container__3MTvK"};